/**
 * LUNAAWELL — mobile menu drawer motion (Scent Nest-style)
 *
 * - Overrides the Stretch theme's enter/leave animation for <header-menu-drawer>
 *   (slide in from the left in 0.42s, out in 0.32s, with the same easing curves as thescentnest.com)
 * - Shifts the page content 4vw to the right while the drawer is open (CSS class on <html>)
 *
 * Nothing here is required for the menu to open: if this file fails to load, the theme's
 * stock animation is used and only the page shift is lost.
 */

(function () {
  const EASE_IN = 'cubic-bezier(0.22, 1, 0.36, 1)';
  const EASE_OUT = 'cubic-bezier(0.55, 0, 0.65, 1)';
  const DURATION_IN = 420;
  const DURATION_OUT = 320;

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /** Wrap Web Animations into the thenable-with-complete() shape the theme expects. */
  function controls(animations) {
    // `finished` only settles on a rendering frame; in a background tab that may never come,
    // so a timer fallback guarantees the dialog always reaches its final state.
    const longest = animations.reduce((max, a) => Math.max(max, Number(a.effect.getTiming().duration) || 0), 0);
    const promise = Promise.race([
      Promise.all(animations.map((a) => a.finished.catch(() => {}))),
      new Promise((resolve) => setTimeout(resolve, longest + 60)),
    ]);
    promise.complete = () => animations.forEach((a) => a.finish());
    return promise;
  }

  function patchAnimations() {
    const DrawerClass = customElements.get('header-menu-drawer');
    if (!DrawerClass) return;

    DrawerClass.prototype.createEnterAnimationControls = function () {
      const overlay = this.getShadowPartByName('overlay');
      const content = this.getShadowPartByName('content');
      const animations = [];

      if (overlay) {
        animations.push(overlay.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, fill: 'both' }));
      }

      if (content) {
        if (reducedMotion()) {
          animations.push(content.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, fill: 'both' }));
        } else {
          animations.push(
            content.animate(
              [{ transform: 'translateX(calc(-100% - 3rem))' }, { transform: 'translateX(0)' }],
              { duration: DURATION_IN, easing: EASE_IN, fill: 'both' }
            )
          );
        }
      }

      return controls(animations);
    };

    DrawerClass.prototype.createLeaveAnimationControls = function () {
      const overlay = this.getShadowPartByName('overlay');
      const content = this.getShadowPartByName('content');
      const animations = [];

      if (overlay) {
        animations.push(overlay.animate([{ opacity: 1 }, { opacity: 0 }], { duration: DURATION_OUT, fill: 'both' }));
      }

      if (content) {
        if (reducedMotion()) {
          animations.push(content.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, fill: 'both' }));
        } else {
          animations.push(
            content.animate(
              [{ transform: 'translateX(0)' }, { transform: 'translateX(calc(-100% - 3rem))' }],
              { duration: DURATION_OUT, easing: EASE_OUT, fill: 'both' }
            )
          );
        }
      }

      return controls(animations);
    };
  }

  function wirePageShift() {
    const drawer = document.getElementById('menu-drawer');
    if (!drawer || drawer.dataset.lwWired) return;
    drawer.dataset.lwWired = 'true';

    const html = document.documentElement;

    drawer.addEventListener('dialog:before-show', () => {
      html.classList.remove('lw-menu-closing');
      html.classList.add('lw-menu-open');
    });

    drawer.addEventListener('dialog:before-hide', () => {
      html.classList.add('lw-menu-closing');
      html.classList.remove('lw-menu-open');
    });

    drawer.addEventListener('dialog:after-hide', () => {
      html.classList.remove('lw-menu-closing');
      // Reset the scroll position of the panel so it always reopens at the top.
      const scroller = drawer.querySelector('.lw-drawer__scroll');
      if (scroller) scroller.scrollTop = 0;
    });
  }

  customElements.whenDefined('header-menu-drawer').then(() => {
    patchAnimations();
    wirePageShift();
  });

  // The header section can be re-rendered in the theme editor; re-wire when that happens.
  document.addEventListener('shopify:section:load', wirePageShift);
})();
